import React from 'react';
interface BonusCardProps {
  imageSrc: string;
  title: string;
  description: string;
}
export function BonusCard({
  imageSrc,
  title,
  description
}: BonusCardProps) {
  return <div className="flex flex-col items-center text-center group" data-id="element-1">
      <div className="relative mb-6 w-full max-w-[280px] aspect-[2/3] shadow-xl rounded-lg overflow-hidden transform transition-transform duration-500 group-hover:scale-105" data-id="element-2">
        <img src={imageSrc} alt={title} className="w-full h-full object-cover" data-id="element-3" />
        <div className="absolute top-4 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 shadow-md rounded-l-md" data-id="element-4">
          GRATIS HOY
        </div>
      </div>
      <h3 className="text-xl font-serif font-bold text-gray-900 mb-2" data-id="element-5">
        {title}
      </h3>
      <p className="text-gray-600 text-sm max-w-xs" data-id="element-6">{description}</p>
    </div>;
}